import log from '@guuru/logger-web';
import { useChatSettings, ChatAPI } from '@guuru/chat-web';
import { LanguageStore } from '@guuru/translation-web';

const useInitChatSettings = function (partnerId: string) {
  const {
    data: {
      chatSettings: {
        name,
        organization,
        language,
      } = {},
    } = {},
    loading,
  } = useChatSettings(partnerId);

  if (loading) {
    return { loading: true };
  }

  if (!name && !organization) {
    log.info(`Partner ${partnerId} not found`);
    return { partnerId: undefined, loading: false };
  }

  if (!organization) {
    ChatAPI.storePartnerId(partnerId);
  }
  LanguageStore.save(language);
  ChatAPI.storeLocale(language);

  return { partnerId, loading: false };
};

export default useInitChatSettings;
